// PRODUCCION

 
 let factMembresiaAbogadoPremiumMensualAnual={
  fac: "5f84c7b642e0a0001b307d7b",
stri:"price_1HbU5FH0Tra8XcMTznzxdFBa"}


let factMembresiaAbogadoPremiumContadoAnual={
  fac: "5f84c82d42e0a0001b307e06",
stri:"price_1HbVYrH0Tra8XcMTWAW1SWqV"}


 let factMembresiaDespachoPremiumMensualAnual={
  fac: "5f84c86c42e0a0001b307e26",
stri:"price_1HbVbXH0Tra8XcMT2lmOvZIA"}



let factMembresiaDespachoPremiumContadoAnual={
  fac: "5f84c85342e0a0001b307e1d",
stri:"price_1HbVehH0Tra8XcMTl111swHd"}




// PRUEBAS
/*
let factMembresiaDespachoPremiumMensualAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_1HcaAMLGoJVGfuzfTWopKwHV"}


let factMembresiaDespachoPremiumContadoAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_1HcaAvLGoJVGfuzfWdk0jN8e"}



let factMembresiaAbogadoPremiumMensualAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_1HcYK2LGoJVGfuzf3wJD0N7Z"}



let factMembresiaAbogadoPremiumContadoAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_1Hca6lLGoJVGfuzf4ywkK5bA"}

*/



/*
let factMembresiaDespachoPremiumMensualSemestral={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaDespachoPremiumMensualAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaDespachoPremiumContadoAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_1Gpz0SH0Tra8XcMT5kUfLSRw"}

let factMembresiaDespachoPremiumPlusMensualSemestral={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaDespachoPremiumPlusMensualAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaDespachoPremiumPlusContadoAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaAbogadoPremiumMensualSemestral={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaAbogadoPremiumMensualAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaAbogadoPremiumContadoAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaAbogadoPremiumPlusMensualSemestral={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaAbogadoPremiumPlusMensualAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}

let factMembresiaAbogadoPremiumPlusContadoAnual={
  fac: "5eecfc009d33d7001b11ae70",
stri:"price_HNnpHIHJhUpokJ"}
*/

export const facturaProduc =(role, type, typePayment)=>{
  return new Promise((resolve, reject) => {

let product;
if(role == "lawyer"){
   
        switch (typePayment) {
            case 'monthly':
              product = factMembresiaAbogadoPremiumMensualAnual;
              break;
           
            case 'yearly':
              product = factMembresiaAbogadoPremiumContadoAnual;
              break;
        }
}else{
    
        switch (typePayment) {
            case 'monthly':
              product = factMembresiaDespachoPremiumMensualAnual;
              break;
            
            case 'yearly':
              product = factMembresiaDespachoPremiumContadoAnual;
              break;
        }
    }
    resolve(product)
  })
}


